import { render, staticRenderFns } from "./PassageRecord.vue?vue&type=template&id=230d041e&scoped=true"
import script from "./PassageRecord.vue?vue&type=script&lang=js"
export * from "./PassageRecord.vue?vue&type=script&lang=js"
import style0 from "./PassageRecord.vue?vue&type=style&index=0&id=230d041e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d041e",
  null
  
)

export default component.exports